import { render, staticRenderFns } from "./PromoNoteValidationList.html?vue&type=template&id=2b10526a&scoped=true&"
import script from "./PromoNoteValidationList.component.js?vue&type=script&lang=js&"
export * from "./PromoNoteValidationList.component.js?vue&type=script&lang=js&"
import style0 from "./PromoNoteValidationList.scss?vue&type=style&index=0&id=2b10526a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b10526a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VIcon,VTooltip})
